import themes from 'themes'
import {
  SCHEDULE_EVENT_COLORS,
  SCHEDULE_EVENT_TYPES,
  SCHEDULE_LESSON_PACK_COLOR,
} from './todays-schedule/schedule-event-colors'

/** themes.js pgaCoach palette.blue.main — Reply button, links, unread dots */
export const PGA_COACH_ACTION_BLUE = themes.pgaCoach.palette.blue.main

/** themes.js common palette.sidebar.activeBg — dashboard icon circles, neutral chips */
export const DASHBOARD_SURFACE_MUTED = themes.common.palette.sidebar.activeBg

/** themes.js common palette.sidebar.itemText — dashboard headings and chip text */
export const DASHBOARD_BODY_TEXT = themes.common.palette.sidebar.itemText

/** benchmarks/styles.js scaleTick — median ticks and neutral benchmark markers */
export const BENCHMARK_SCALE_TICK = '#C5D0D6'

/** themes.js pgaCoach palette.primary.main — coach marker on benchmark detail scale */
export const BENCHMARK_COACH_MARKER = themes.pgaCoach.palette.primary.main

/** requirements/status-chip success + profile-overview promotionStatusPromoted */
export const PGA_COACH_SUCCESS_BG = '#BEF1BB'
export const PGA_COACH_SUCCESS_TEXT = '#00210B'

/** profile-overview error banners — negative revenue deltas */
export const PGA_COACH_ERROR_BG = '#FFEBEE'
export const PGA_COACH_ERROR_TEXT = '#C62828'

/** schedule-event-colors GROUP_EVENT badge — top-10 benchmark chips */
export const PGA_COACH_GROUP_BADGE_BG = '#F1E9D8'
export const PGA_COACH_GROUP_BADGE_TEXT = '#5C4922'

/** schedule-event-colors GROUP_EVENT accent — top-10 benchmark bar fill */
export const PGA_COACH_GROUP_EVENT_COLOR =
  SCHEDULE_EVENT_COLORS[SCHEDULE_EVENT_TYPES.GROUP_EVENT]

/** schedule-event-colors PRIVATE accent — booking mix private segment */
export const PGA_COACH_PRIVATE_LESSON_COLOR =
  SCHEDULE_EVENT_COLORS[SCHEDULE_EVENT_TYPES.PRIVATE]

/** Weekly revenue line, gradient, and dots — same token as coach action blue */
export const WEEKLY_REVENUE_CHART_COLOR = PGA_COACH_ACTION_BLUE

export const BOOKING_MIX_SEGMENT_COLORS = {
  private: PGA_COACH_PRIVATE_LESSON_COLOR,
  group: PGA_COACH_GROUP_EVENT_COLOR,
  packages: SCHEDULE_LESSON_PACK_COLOR,
}

export const BENCHMARK_PALETTE = {
  neutral: {
    track: DASHBOARD_SURFACE_MUTED,
    chipBackground: DASHBOARD_SURFACE_MUTED,
    chipText: DASHBOARD_BODY_TEXT,
    barFill: BENCHMARK_SCALE_TICK,
    marker: BENCHMARK_SCALE_TICK,
  },
  success: {
    chipBackground: PGA_COACH_SUCCESS_BG,
    chipText: PGA_COACH_SUCCESS_TEXT,
    barFill: PGA_COACH_SUCCESS_BG,
  },
  top10: {
    chipBackground: PGA_COACH_GROUP_BADGE_BG,
    chipText: PGA_COACH_GROUP_BADGE_TEXT,
    barFill: PGA_COACH_GROUP_EVENT_COLOR,
  },
}
